import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, HostListener, Input } from '@angular/core';

@Component({
  selector: 'ac-icon-button',
  standalone: true,
  template: ` <ng-content /> `,
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  /** HOST CLASSES */
  @HostBinding('class.disabled')
  @Input()
  public disabled: boolean = false;

  /** HOST ATTRIBUTES */
  @HostBinding('attr.role') role: string = 'button';

  @HostBinding('attr.tabindex') tabIndex: number = 0;

  @HostBinding('attr.label') @Input() label?: string;

  // Optional attributes

  // Optional attributes
  // dark_negative (for inputs in dark backrounds)
  // primary_negative (for inputs in red primary backrounds)
  @Input({ transform: booleanAttribute }) dark_negative?: boolean | string;

  @Input({ transform: booleanAttribute }) primary_negative?: boolean | string;

  @Input() size: 'small' | 'general' | 'big' = 'general';

  /**
   * stopPropagationIfDisabled
   * prevent and stop event propagation
   * if button is disabled.
   *
   * @param event Event
   * @returns boolean
   */
  @HostListener('click', ['$event'])
  @HostListener('Keydown.space', ['$event'])
  @HostListener('Keydown.enter', ['$event'])
  stopPropagationIfDisabled(event: Event): boolean {
    if (this.disabled) {
      event.stopImmediatePropagation();
      return false;
    }
    return true;
  }
}
